import React from 'react';

function Insights({ insights }) {
  const getInsightClass = (type) => {
    switch (type) {
      case 'success':
        return 'insight success';
      case 'warning':
        return 'insight warning';
      case 'info':
        return 'insight info';
      default:
        return 'insight';
    }
  };

  const getInsightIcon = (type) => {
    switch (type) {
      case 'success':
        return '✓';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '•';
    }
  };

  if (!insights || insights.length === 0) {
    return null;
  }

  return (
    <div className="insights">
      <h3>Insights</h3>
      <div className="insights-list">
        {insights.map((insight, index) => (
          <div key={index} className={getInsightClass(insight.type)}>
            <div className="insight-header">
              <span className="insight-icon">{getInsightIcon(insight.type)}</span>
              <strong>{insight.title}</strong>
            </div>
            <p>{insight.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Insights;
